import type { TPlansButtonAction } from "../types";

type TPlansButtonVariantActionProps = {
  wrapperClass: string;
  titleClass: string;
  textClass: string;
  wrapperBallClass: string;
  centerBallClass: string;
};

type TPlansButtonVariant = {
  [key in TPlansButtonAction]: TPlansButtonVariantActionProps;
};

export const planButtonVariant: TPlansButtonVariant = {
  active: {
    wrapperClass: "bg-gray-180 hover:bg-gray-180",
    titleClass: "text-blue-500",
    textClass: "text-blue-500",
    wrapperBallClass: "border-0",
    centerBallClass: "bg-blue-500",
  },
  inactive: {
    wrapperClass: "bg-white hover:bg-gray-50",
    titleClass: "text-gray-450",
    textClass: "text-gray-450",
    wrapperBallClass: "border border-gray-190",
    centerBallClass: "bg-white",
  },
};
